"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getIntegrationPath;

var _isLocal = _interopRequireDefault(require("./isLocal.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var packageToFolder = {
  tpaIntegration: 'Santa-Integration-Protractor',
  wixCodeIntegration: 'js-wixcode-integration',
  viewerIntegration: 'viewer-integration',
  platformIntegrationEditor: 'js-platform-integration',
  tpaIntegrationEditor: 'Santa-Editor-Integration-Protractor'
};

function getLocalBasePath(baseArtifact) {
  var protocol = (/^https?:/.exec(baseArtifact) || [''])[0];
  return "".concat(protocol, "//localhost:4578");
}

function getIntegrationPath(packageName, baseArtifact) {
  var integrationBasePath = (0, _isLocal["default"])(baseArtifact) ? getLocalBasePath(baseArtifact) : "https://s3.amazonaws.com/integration-tests-statics/".concat(packageToFolder[packageName], "/SNAPSHOT/runners");
  return "".concat(integrationBasePath, "/").concat(packageName, "/src/main");
}
//# sourceMappingURL=getIntegrationPath.js.map